// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "592f97f370139e0f2d86" + ".css";
};